import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const accordion = () => {

	let els = document.querySelectorAll('[animation="accordion"]')

	if (!els.length || window.innerWidth <= 720) return

	els.forEach(el => {

		let items = el.querySelectorAll('[data-el="item"]')

		let smallHeight = items[items.length - 1].offsetHeight,
			largeHeight = items[0].offsetHeight,
			end = '+=' + (largeHeight * items.length)

		let tl = gsap.timeline({
			ease: 'none',
			scrollTrigger: {
				trigger: el,
				start: "top top",
				end: end,
				scrub: true,
				pin: true,
				// markers: true,
			}
		});

		items.forEach((item, index) => {

			if (index !== 0) {
				tl.to(item, {
					height: largeHeight,
					duration: 1
				}, '-=1');
			}

			if (index < items.length - 1) {
				tl.to(item, {
					height: smallHeight,
					duration: 1
				}, "+=0");
			}
		});
	})
}

export default () => { }